import { Trans } from '@lingui/react/macro';
import React from 'react';

import { DestructivePrimaryButton, PrimaryButton, SecondaryButton } from '../../buttons';
import { Text } from '../../Text';
import { Dialog } from '../Dialog';
import { DialogActions } from '../DialogActions';
import { DialogContent } from '../DialogContent';
import { DialogTitle } from '../DialogTitle';

export function useConfirmationDialog({
    title,
    description,
    onConfirmation,
    cta = <Trans>Yes, I'm sure</Trans>,
    cancelLabel = <Trans>Cancel</Trans>,
    variant = 'destructive',
}: {
    onConfirmation: () => void;
    title: string;
    description: string | JSX.Element;
    cta?: string | JSX.Element;
    cancelLabel?: string | JSX.Element;
    variant?: 'destructive' | 'primary';
}): { modal: JSX.Element; setOpen: React.Dispatch<React.SetStateAction<boolean>>; open: boolean } {
    const [open, setOpen] = React.useState(false);

    const ModalButton = variant === 'destructive' ? DestructivePrimaryButton : PrimaryButton;

    const modal = (
        <Dialog maxWidth="xs" open={open} onClose={() => setOpen(false)}>
            <DialogTitle title={title} onClose={() => setOpen(false)} />
            <DialogContent>
                <Text>{description}</Text>
            </DialogContent>
            <DialogActions>
                <SecondaryButton autoFocus size="medium" onClick={() => setOpen(false)}>
                    {cancelLabel}
                </SecondaryButton>
                <ModalButton
                    size="medium"
                    onClick={() => {
                        setOpen(false);
                        onConfirmation();
                    }}
                >
                    {cta}
                </ModalButton>
            </DialogActions>
        </Dialog>
    );

    return {
        modal,
        setOpen,
        open,
    };
}
